import { GetStatement_listStatements_installmentsOverdue } from '../types/GetStatement'
import { openPaymentSlip } from './openPaymentSlip'
import { registerBankSlip } from './registerBankSlip'
import { timeout } from '../../utils/timeout'

export interface Installment extends GetStatement_listStatements_installmentsOverdue {}

const INTERVAL_BETWEEN_API_CALLS_MILLIS = 1000

export const updateManyBankSlips = async (installments: Installment[]) => {
  try {
    await Promise.all(
      installments.map(async ({ receivableBillId, installmentId, dueDate: newDueDate }, index) => {
        await timeout(INTERVAL_BETWEEN_API_CALLS_MILLIS * index)
        try {
          const inputOpenPayment = {
            receivableBillId: receivableBillId.toString(),
            installmentId: installmentId.toString(),
            newDueDate,
          }
          await openPaymentSlip(inputOpenPayment)
        } catch (error) {
          console.log(error, 'error open one bank slip in many')
        }
      })
    )
    await timeout(INTERVAL_BETWEEN_API_CALLS_MILLIS)
    await Promise.all(
      installments.map(async ({ receivableBillId, installmentId }, index) => {
        await timeout(INTERVAL_BETWEEN_API_CALLS_MILLIS * index)
        try {
          await registerBankSlip({ receivableBillId: Number(receivableBillId), installmentId })
        } catch (error) {
          console.log(error, 'error register one bank slip in many')
        }
      })
    )
  } catch (error) {
    console.log(error, 'error update many bank slips')
  }

  return installments
}
